<h3 class="flex flex-justify-between m-t-2 p-t-2 p-t-4-m p-t-4-s p-r p-b-2 p-b-4-m p-b-4-s p-l bg-col-11"
    [ngClass]="{'visually-hidden' : !isCurrent}">
    <span class="ls-1 fw-bold">{{'Card verification' | translate}}</span>
</h3>
<div class="p-t p-r p-b-2 p-l"
     [ngClass]="{'visually-hidden' : !isCurrent}">
    <p class="m-b col-2">{{'Please do not refresh this page, transaction still in progress' | translate}}</p>
    <div class="pos-relative center">
        <div class="fill">
            <div class="vc-outer">
                <div class="vc-inner center">
                    <i class="busy-state-animation"></i>
                </div>
            </div>
        </div>
        <div #container
             class="checkout-confirmation-iframe m-t">
        </div>
    </div>
</div>